import { useCallback, useEffect, useState } from 'react';
import { RuleListStatus } from '../../../types';
import { useCollapseItems } from '../../../utils/use-on-rule-group-toggle';
import { useUnsavedChangesHandlers } from '../../../utils/use-unsaved-changes-handlers';
export const useDropdownFixer = (ruleResult, selected) => {
  var _footerLabels$buttonT;
  const {
    onApply,
    onCancel,
    onClick,
    onEdit,
    options,
    initialValue,
    onSelect,
    footerLabels
  } = ruleResult.fixerProps;
  const {
    tips,
    description
  } = ruleResult;
  const unsavedChangesHandlers = useUnsavedChangesHandlers();
  const {
    collapseRule
  } = useCollapseItems();
  const [isEditMode, setIsEditMode] = useState(false);
  const [value, setValue] = useState(initialValue ?? null);
  const [searchValue, setSearchValue] = useState((initialValue == null ? void 0 : initialValue.value) ?? '');
  const [showLoader, setShowLoader] = useState(false);
  useEffect(() => {
    if (!selected) {
      setIsEditMode(false);
    }
    return () => {
      setIsEditMode(false);
      setShowLoader(false);
    };
  }, [selected]);
  const onApplyClick = useCallback(async newValue => {
    if (!newValue) {
      throw new Error('onApply was called with null value');
    }
    setShowLoader(true);
    try {
      await onApply(newValue);
      unsavedChangesHandlers == null || unsavedChangesHandlers.setUnsavedChanges(false, () => Promise.resolve());
    } catch (e) {
      console.error(e);
    } finally {
      setShowLoader(false);
    }
  }, [onApply, unsavedChangesHandlers]);
  const onSelectValue = useCallback(selectedOption => {
    setValue(selectedOption);
    setSearchValue(selectedOption.value ?? '');
    onSelect == null || onSelect(selectedOption.value ?? '');
    if (selectedOption.id === (initialValue == null ? void 0 : initialValue.id)) {
      unsavedChangesHandlers == null || unsavedChangesHandlers.setUnsavedChanges(false, () => Promise.resolve());
    } else {
      unsavedChangesHandlers == null || unsavedChangesHandlers.setUnsavedChanges(true, () => onApplyClick(selectedOption));
    }
  }, [initialValue == null ? void 0 : initialValue.id, onApplyClick, onSelect, setValue, unsavedChangesHandlers]);
  const onEditClick = useCallback(() => {
    setIsEditMode(true);
    onEdit == null || onEdit();
  }, [setIsEditMode, onEdit]);
  const onCancelClick = useCallback(() => {
    collapseRule();
    setIsEditMode(false);
    setValue(initialValue ?? null);
    onCancel == null || onCancel();
    unsavedChangesHandlers == null || unsavedChangesHandlers.setUnsavedChanges(false, () => Promise.resolve());
  }, [collapseRule, initialValue, onCancel, setValue, unsavedChangesHandlers]);
  return {
    description,
    fieldLabel: ruleResult.fixerProps.fieldLabel,
    isEditMode,
    onClick: () => onClick == null ? void 0 : onClick(),
    onEditClick,
    onSelectValue,
    options,
    ruleFooterProps: {
      dismissButtonProps: {
        label: footerLabels.dismiss,
        onClick: onCancelClick,
        type: ((_footerLabels$buttonT = footerLabels.buttonTypes) == null ? void 0 : _footerLabels$buttonT.dismiss) ?? 'textButton'
      },
      submitButtonProps: {
        disabled: !value || ruleResult.status !== RuleListStatus.failed && value.value === (initialValue == null ? void 0 : initialValue.value),
        label: footerLabels.submit,
        onClick: () => onApplyClick(value),
        showLoader
      }
    },
    searchValue,
    setSearchValue,
    tips,
    value
  };
};
//# sourceMappingURL=use-dropdown-fixer.js.map